import {RouterProps} from "../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {
    ContentDetailUrlValueObject
} from "../../../data/value-object/content/ContentDetailUrlValueObject";
import {useEffect} from "react";
import {ContentDetailUrlIO} from "../../../io/ContentIO";
import {Body1, Spinner} from "@fluentui/react-components";
import {ContentDetailUrlDescription} from "../../../data/description/content/ContentDetailUrlDescription";
import {ContentDetailUrlDomain} from "../../../data/domain/content/ContentDetailUrlDomain";
import {ContentDetailUrlDescriptor} from "../../../data/descriptor/content/ContentDetailUrlDescriptor";
import {DetailDefaultPanel, DetailDefaultTab} from "../../DetailViews";

export default function Detail(props: RouterProps) {
    const params = useParams<{ contentDetailUrlId: string }>()
    const item = useStatePair<ContentDetailUrlValueObject | undefined>(undefined)

    useEffect(() => {
        if (item.value === undefined && params.contentDetailUrlId !== undefined) {
            ContentDetailUrlIO
                .getById(BigInt(params.contentDetailUrlId))
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && <Page {...props} item={item.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: ContentDetailUrlValueObject
}

function Page(props: PageProps) {
    return <>
        <div className={props.styles.row16}>
            <DetailDefaultTab {...props} />
            <DetailDefaultPanel
                {...props}
                client={ContentDetailUrlIO}
                description={ContentDetailUrlDescription}
                properties={props => <PropertyBody {...props} />}
                hideEdit
                hideDelete/>
        </div>
    </>
}

type PropertyBodyProps = PageProps & {
    itemKey: keyof ContentDetailUrlDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "browser":
        case "url":
        case "clickCount":
        case "createdAt":
        case "lastModifiedAt":
        case "concealedAt":
            return <Body1>{ContentDetailUrlDescriptor[props.itemKey](props.item)}</Body1>
        case "creatorId":
            return <a href={`/users/${props.item.creatorId}`}><Body1>{ContentDetailUrlDescriptor[props.itemKey](props.item)}</Body1></a>
    }
}